import React from 'react';
import './GameOver.css'; // Create and import your CSS for styling and animations

const GameOver = ({ backgroundColor, scrapsEarned, highestChop, onRestart }) => {
    return (
        <div style={{ backgroundColor: backgroundColor, height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <h1>Game Over</h1>
            <p>Scraps earned: {scrapsEarned}</p>
            <p>Highest chop of the session: {highestChop}</p>
            <div className="png-container">
                {/* Place your PNGs here with proper CSS classes for animations */}
            </div>
            <button onClick={onRestart}>Chop More</button>
        </div>
    );
};

export default GameOver;
